import { AddWorkflowCheckpointPayload } from '../api/addWorkflowCheckpoint';

/**
 * Utility to add a new checkpoint.
 * @param params - parameters for checkpoint update
 */
export async function updateWorkflowWithCheckpoint(params: {
  projectId: string;
  workflow_id: string;
  workflowName: string;
  api_workflow_file_id: string;
  normal_workflow_file_id: string;
  newVersion: number;
  checkpointInputs: any[];
  checkpointOutputs: any[];
  is_manual: boolean;
  commitMessage: string;
  commitAuthor: string;
  /** Mutation to add single checkpoint */
  addSingle: (args: { project_id: string; payload: AddWorkflowCheckpointPayload }) => void;
}) {
  const {
    projectId,
    workflow_id,
    workflowName,
    api_workflow_file_id,
    normal_workflow_file_id,
    newVersion,
    checkpointInputs,
    checkpointOutputs,
    is_manual,
    commitMessage,
    commitAuthor,
    addSingle,
  } = params;

  // Create the new checkpoint item
  const newItem = {
    workflow_id,
    workflow_name: workflowName,
    version: newVersion,
    api_workflow_file_id,
    normal_workflow_file_id,
    commit_author: commitAuthor,
    created_at: new Date().toISOString(),
    api_config: {
      inputs: checkpointInputs,
      outputs: checkpointOutputs,
      is_manual,
    },
    commit_message: `v${newVersion}: ${commitMessage}`,
  };

  addSingle({
    project_id: projectId,
    payload: newItem,
  });
}
